<app-portal-navigation
  [portalName]="portalName"
  [portalIcon]="portalIcon"
  [portalClass]="portalClass"
  collapseId="settingsMenu"
  [firstName]="userProfile?.firstName ?? ''"
  [lastName]="userProfile?.lastName ?? ''"
  [primaryItems]="primaryNavigationItems"
  [profileRoute]="profileRoute"
  [additionalItems]="additionalNavigationItems"
  [clinicMemberships]="clinicMemberships"
  (switchClinic)="onSwitchClinic($event)"
>
</app-portal-navigation>

<div class="container-fluid p-3 p-md-4" style="max-width: 1400px">
  <!-- Hero Banner -->
  <div class="booking-hero card border-0 mb-4">
    <div class="booking-hero__content">
      <div>
        <div class="booking-hero__eyebrow">Practice Administration</div>
        <h2 class="booking-hero__title mb-1">Practice & System Settings</h2>
        <div class="booking-hero__meta">
          <span
            ><i class="bi bi-gear-wide-connected me-1 text-primary"></i>Configure security, pricing
            catalogue, schedule rules, and notifications</span
          >
        </div>
      </div>
    </div>
  </div>

  <div class="card booking-card">
    <div class="card-body p-0">
      <div class="row g-0">
        <!-- Sidebar Tabs -->
        <div class="col-lg-3 border-end bg-light">
          <div class="list-group list-group-flush settings-tabs p-3">
            <button
              class="list-group-item list-group-item-action mb-2 rounded-3"
              [class.active]="activeTab === 'security'"
              (click)="setActiveTab('security')"
            >
              <i class="bi bi-shield-lock me-2"></i>
              Security
            </button>

            <button
              class="list-group-item list-group-item-action mb-2 rounded-3"
              [class.active]="activeTab === 'notifications'"
              (click)="setActiveTab('notifications')"
            >
              <i class="bi bi-bell me-2"></i>
              Notifications
            </button>

            @if (['RECEPTION', 'DOCTOR', 'MANAGER'] | hasRole) {
              <button
                class="list-group-item list-group-item-action mb-2 rounded-3"
                [class.active]="activeTab === 'appearance'"
                [class.disabled]="!isClinicActive"
                [class.text-muted]="!isClinicActive"
                [attr.title]="!isClinicActive ? 'Not available until practice is active' : null"
                (click)="isClinicActive && setActiveTab('appearance')"
              >
                <i class="bi bi-palette me-2"></i>
                Appearance
              </button>

              <button
                class="list-group-item list-group-item-action mb-2 rounded-3"
                [class.active]="activeTab === 'pricing'"
                [class.disabled]="!isClinicActive"
                [class.text-muted]="!isClinicActive"
                [attr.title]="!isClinicActive ? 'Not available until practice is active' : null"
                (click)="isClinicActive && setActiveTab('pricing')"
              >
                <i class="bi bi-tags-fill me-2"></i>
                Consultation Pricing
              </button>
            }

            @if ('MANAGER' | hasRole) {
              <button
                class="list-group-item list-group-item-action mb-2 rounded-3"
                [class.active]="activeTab === 'working-hours'"
                (click)="setActiveTab('working-hours')"
              >
                <i class="bi bi-clock-history me-2"></i>
                Working Hours
              </button>

              <button
                class="list-group-item list-group-item-action rounded-3"
                [class.active]="activeTab === 'billing'"
                [class.disabled]="!isClinicActive"
                [class.text-muted]="!isClinicActive"
                [attr.title]="!isClinicActive ? 'Not available until practice is active' : null"
                (click)="isClinicActive && setActiveTab('billing')"
              >
                <i class="bi bi-credit-card me-2"></i>
                Billing Settings
              </button>

              <button
                class="list-group-item list-group-item-action mt-2 rounded-3"
                [class.active]="activeTab === 'subscription'"
                (click)="setActiveTab('subscription')"
              >
                <i class="bi bi-calendar2-check me-2"></i>
                Practice Subscription
              </button>
            }
          </div>
        </div>

        <!-- Settings Content -->
        <div class="col-lg-9">
          <div class="p-3 p-md-4">
            @switch (activeTab) {
              @case ('security') {
                <app-security-settings></app-security-settings>
              }

              @case ('notifications') {
                <app-notifications-settings></app-notifications-settings>
              }

              @case ('appearance') {
                <app-appearance-settings></app-appearance-settings>
              }

              @case ('pricing') {
                <app-pricing-settings></app-pricing-settings>
              }

              @case ('working-hours') {
                <app-hours-settings></app-hours-settings>
              }

              @case ('billing') {
                <app-billing-settings></app-billing-settings>
              }

              @case ('subscription') {
                <app-subscription-settings></app-subscription-settings>
              }
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
